const inputWrapper = "_275i4joqr4";
const input = "_275i1ad0zuh";
const inputPlaceholder = "_275i1s4abtn";
const sendButton = "_275s1vindjh";

export { input, inputPlaceholder, inputWrapper, sendButton };
import "./atom.input.style.linaria.module.css";
//# sourceMappingURL=atom.input.style.js.map
